import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { BaseService } from 'app/core/base.service';
import { Machine } from './machine';
import { CustomValidators } from 'app/shared/form/custom.validators';
import { map, catchError } from 'rxjs/operators';
import * as moment from 'moment';

@Injectable()
export class MachineService {
	private static readonly BASE_URL: string = BaseService.HOST + '/machines';

	constructor(
		private http: HttpClient,
		private fb: FormBuilder
	) {}

	getById(id: number): Observable<Machine> {
		return this.http.get(MachineService.BASE_URL + '/' + id)
			.pipe(
				map(BaseService.extractData),
				catchError(BaseService.handleError)
			);
	}

	getAll(params: HttpParams): Observable<any> {
		return this.http.get(MachineService.BASE_URL, {params: params})
			.pipe(catchError(BaseService.handleError));
	}

	create(machine: Machine): Observable<Machine> {
		return this.http.post(MachineService.BASE_URL, machine)
			.pipe(
				map(BaseService.extractData),
				catchError(BaseService.handleError)
			);
	}

	update(machine: Machine): Observable<Machine> {
		return this.http.put(MachineService.BASE_URL + '/' + machine.id, machine)
			.pipe(
				map(BaseService.extractData),
				catchError(BaseService.handleError)
			);
	}

	delete(id: number): Observable<any> {
		return this.http.delete(MachineService.BASE_URL + '/' + id)
			.pipe(catchError(BaseService.handleError));
	}

	deletes(machines: Machine[]): Observable<any> {
		return this.http.post(MachineService.BASE_URL + '/delete', machines)
			.pipe(catchError(BaseService.handleError));
	}

	toFormGroup(machine: Machine): FormGroup {
		let formGroup = this.fb.group({
			id: new FormControl(machine.id),
			serial: new FormControl(machine.serial, [Validators.required, Validators.maxLength(100)]),
			purchaseDate: new FormControl(
				machine.purchaseDate ? moment(machine.purchaseDate) : undefined
			),
			factoryWarrantyExpiration: new FormControl(
				machine.factoryWarrantyExpiration ? moment(machine.factoryWarrantyExpiration) : undefined
			),
			localWarrantyTime: new FormControl(machine.localWarrantyTime, [CustomValidators.integerRegex, CustomValidators.min(0)]),
			swVersion: new FormControl(machine.swVersion),
			usedDistance: new FormControl(machine.usedDistance, [CustomValidators.numberRegex, CustomValidators.min(0)]),
			maintenenceFrecuency: new FormControl(machine.maintenenceFrecuency, [CustomValidators.integerRegex, CustomValidators.min(0)]),
			maintenencePerDistance: new FormControl(machine.maintenencePerDistance, [CustomValidators.numberRegex, CustomValidators.min(0)]),
			store: new FormControl(machine.store, Validators.required),
			statusMachine: new FormControl(machine.statusMachine, Validators.required),
			machineModel: new FormControl(machine.machineModel ? {id: machine.machineModel.id} : undefined, Validators.required)
		});
		return formGroup;
	}
}
